import React from 'react';

interface SortableTableHeaderProps {
  label: string;
  sortKey: string;
  currentSortOrder: number | '';
  onSort: (sortKey: string) => void;
  className?: string;
}

/**
 * Sortable table header cell with sort icon indicator
 *
 * @param label - Display text for the header
 * @param sortKey - Key to pass to onSort callback
 * @param currentSortOrder - Current sort order (1 for asc, -1 for desc, '' for none)
 * @param onSort - Callback when header is clicked
 * @param className - Additional CSS classes
 *
 * @example
 * <SortableTableHeader
 *   label="Sport Name"
 *   sortKey="sportname"
 *   currentSortOrder={sortOrder}
 *   onSort={sortData}
 * />
 */
export const SortableTableHeader: React.FC<SortableTableHeaderProps> = ({
  label,
  sortKey,
  currentSortOrder,
  onSort,
  className = '',
}) => {
  return (
    <th
      scope="col"
      onClick={() => onSort(sortKey)}
      className={`cursor-pointer ${className}`}
    >
      {label}{' '}
      {currentSortOrder === 1 ? (
        <i className="fa fa-sort-amount-asc" aria-hidden="true"></i>
      ) : (
        <i className="fa fa-sort-amount-desc" aria-hidden="true"></i>
      )}
    </th>
  );
};

export default SortableTableHeader;
